/* globals $:false */

import tmpl from '../templates/definition-field.dot';

import utils from '@cob/ui-genesis/cob.utils.js';

// View to edit a Field
//
// callbacks:
//
//  * `toggle_group`: Enable or disable the possibility of having children.
//  * `toggle_children`: Open or close the child container. Only used in group type fields.
//  * `bottom_child_add`: Called when the user wants to add a field after this field.
//  * `bottom_child_drop`: Called when the user drops a field after this field
//  * `remove`: Called when the user deletes the field
var DefinitionFieldV = function(core, callbacks) {

    var _$element = {};
    var _fieldId;
    var _$fieldName;
    var _$fieldDescription;
    var _$bottomInsertionPoint;

    var _addConditionList = function(condListP) {
        _$element.children(".condition-list-block").append(condListP.content());
    };

    var _expandFields = function() {
        _$element.children(".condition-list-block").removeClass('hidden');
        _$element.children('table').find(".toggle-button .icon-chevron-right").addClass("icon-rotate-90");
    };

    var _colapseFields = function() {
        _$element.children(".condition-list-block").addClass('hidden');
        _$element.children('table').find(".toggle-button .icon-chevron-right").removeClass("icon-rotate-90");
    };

    var _getModel = function() {
        var desc = _$fieldDescription.val();
        desc = desc.replace(/\$\[([^\]]*)\]/, function(a, x) {
            var y = x.split(",");
            y.forEach(function(el, idx) {
                y[idx] = el.trim();
            });
            return a.replace(x, y.join(','));
        });

        return {
            "id": String(_fieldId),
            "name": _$fieldName.val().trim(),
            "description": desc,
            "duplicable": _$element.find("#duplicable-" + _fieldId).prop('checked'),
            "required": _$element.find("input:radio[name=required-group-" + _fieldId + "]:checked").val()
        };
    };

    return{
        showField: function(field, nanny) {
            _fieldId = field.id;
            field.htmlEncodedName = utils.encodeHTML(field.name);
            field.htmlEncodedDescription = utils.encodeHTML(field.description);

            _$element = $(tmpl(field));

            _$fieldName = _$element.find("#name-" + field.id);
            _$fieldName.on('input', function () {
                var splitChar = (_$fieldName.val().indexOf('|§|') > 0 ? '|§|' : '\t');
                var pastedLines = _$fieldName.val().split(splitChar);
                if (pastedLines.length > 1) {
                    _$fieldName.val(pastedLines.shift().trim());
                    pastedLines.reverse().forEach(function(nextValue) {
                        //the first argument would be the event
                        callbacks.bottom_field_add(undefined, nextValue.trim());
                    })

                }
            });
            _$fieldDescription = _$element.find("#description-" + field.id);

            _$bottomInsertionPoint = _$element.children('div.field-insertion-point');
            _$bottomInsertionPoint.on('click', callbacks.bottom_field_add);
            _$element.droppable({
                //class added to the element while something is beeing dragged
                activeClass: 'def-state-active',

                //class added to the elemente while something is hovering above it
                hoverClass: 'def-state-hover',

                // don't add the dropped element to parent droppables
                greedy: true,

                // called when the element is actually dropped
                drop: function(event, ui) {
                    var _$draggedElement = ui.draggable;
                    //para a li voltar à lista e não ficar com o offset do fim do drag
                    _$draggedElement.attr('style', 'position:relative;');

                    callbacks.bottom_field_drop(_$draggedElement);
                }
            });

            _$element.children('table').find(".toggle-button").click(callbacks.toggle_children);
            _$element.find("#group-" + _fieldId).click(callbacks.toggle_group);

            if (field.required) {
                _$element.find('#required-group-' + _fieldId + '-' + field.required.toLowerCase())
                    .prop('checked', true);
            } else {
                _$element.find('#required-group-' + _fieldId + '-no').prop('checked', true);
            }

            _$element.children("table").find("span.remove-button").on('click', callbacks.remove);

            _$element
                //we need the id to get the presenter from the nanny when dropping
                .data('fieldId', field.id)
                //we need the nanny to be able to remove this field from it, when dropping on another field
                .data('nanny', nanny)
                .draggable({
                    // where to attach the helper element, while it's being dragged
                    appendTo: '#'+core.getAppInstanceId(),

                    // does not return to the starting position after beeing dropped
                    revert: 'invalid',

                    // only start the drag if the mousedown is over this element
                    handle: '.drag-handle'
                });
        },
        getContainer: function() {
            return _$element;
        },
        getConditionListContainer: function(){
            return _$element.children(".condition-list-block");
        },

        isChildBlockVisible: function(){
            return _$element.children('.condition-list-block').is(':visible');
        },
        expandFields: _expandFields,
        colapseFields: _colapseFields,

        focusNameField: function() {
            _$fieldName.focus();
        },
        addConditionList: _addConditionList,

        getModel: _getModel,

        showNameError: function() {
            _$fieldName.addClass("error");
        },
        hideNameError: function() {
            _$fieldName.removeClass("error");
        },

        clearErrors: function() {
            _$element.removeClass('error')
                .children(".field-errors").html("");
        },
        showErrors: function(errors) {
                _$element.addClass("error")
                    .children(".field-errors").removeClass("hidden")
                    .html(errors
                       .map((e) => (e.part ? `<code>${e.part}</code>:` : '') + e.errorMsg)
                       .join('<br/>')
                    );
        },

        // add a field after this one
        addBottomField: function(field){
            _$element.after(field.content());

            field.focus();
        },

        // destroy this element's DOM nodes.
        destroy: function(){
            _$element.remove();
        }
    }
};

export default DefinitionFieldV;
